import { css, cva } from '@onbeam/business-styled-system/css';

const fadeOutItem = css.raw({
  zIndex: 2,
  content: '""',
  position: 'absolute',
  top: '0',
  h: 'full',
  w: '[9.375rem]',
  bg: '[linear-gradient(270deg, transparent 0%, token(colors.mono.primaryFg) 100%)]',
  pointerEvents: 'none',
});

export const fadeOut = cva({
  base: {
    position: 'relative',

    _before: {
      ...fadeOutItem,
      left: '0',
    },
    _after: {
      ...fadeOutItem,
      right: '0',
      transform: 'rotate(180deg)',
    },
  },
});
